export const getPictureUrl = (picture?: string) => {
  if (!picture) return ''
  return picture
}

export const normalizeItemTitle = (itemName: string) => {
  return itemName.replace(/[^a-zA-Z0-9\s]/gim, '').replace(/\s/gim, '-')
}
